export enum LogoColorVariant {
    normal = 1962,
    white = 1964,
    black = 1963
}

export enum LogoSizeVariant {
    Full = 2023,
    Editor = 2024,
    Preview = 2025
}

export enum LogoConfirm {
    New = 2017, // New Uploaded
    ToCheck = 2018, // To Check By Agency
    OK = 2019, // OK
    Terminated = 2020 // Terminated
}

export interface ILogoInfo {
    logoId: string;
}


export interface ILogoVersionInfo {
    variant: LogoColorVariant;
    src: string;
    isLoaded: boolean;
    accept: boolean;
}

export interface ILogoStateInfo {
    logoId: string;
    normal: ILogoVersionInfo;
    white: ILogoVersionInfo;
    black: ILogoVersionInfo;
}

export enum LogoClearMethod {
    None = 0,
    Full = 1,
    Edge = 2
}

export enum EditorButtonsFunctions  {
    DownloadMotive = 25203, // Download Motive As Image
    DownloadVisualization = 25204, // Download Visualization As Image
    PdfVisualization = 25202, // Create Pdf Visualization
    QuickSave = 25201, // Quick Save Motive And Continue
    SaveSelection = 25200, // Save Motive With Selection
}



// WEBPACK FOOTER //
// ./src/App/shared/logo.types.tsx